export default {
  satisfactionModalAriaLabel: 'Satisfaction Form Modal',
  satisfactionMessageModalFeedback: 'Thanks for your feedback!',
  submitSatisfactionSubmitButton: 'Submit',
};
